import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useOnClose } from '@core/js/components/common/PopupManager';

import { useTranslations } from '@core/js/hooks/i18n';

import { CONTACT_TYPES_FRONT } from '@interlayer/js/app/components/main/MarketingPreferences/constants';
import { OPTED_OUT_CONFIRMATION } from '@interlayer/js/app/components/main/UserDetails/constants';
import { showCommonPopupAction } from '@interlayer/js/components/common/popups/CommonPopup/actions';

import style from '../MarketingPreferences.scss';

type TOptedOutPopupProps = {
    changeValue: () => void;
    type: 'slotClubOptOut' | CONTACT_TYPES_FRONT.email | CONTACT_TYPES_FRONT.SMS;
}

export const useShowOptedOutInformationPopup = () => {
    const onClose = useOnClose();
    const dispatch = useDispatch();
    const t = useTranslations('playtech.mobile.system.userdetails.slotClubOptedIn.popup.');

    return useCallback(({ changeValue, type }: TOptedOutPopupProps) => {
        const translate = (key: string) => t(`${type}.${key}`);

        dispatch(showCommonPopupAction({
            id: OPTED_OUT_CONFIRMATION,
            title: translate('title'),
            content: translate('description'),
            fullscreen: true,
            buttons: [
                {
                    text: translate('confirm'),
                    className: style.confirmBtn,
                    onClick: () => {
                        changeValue();
                        onClose();
                    }
                },
                {
                    text: translate('close'),
                    view: 'link',
                    onClick: onClose
                }
            ]
        }));
    }, [dispatch, onClose, t]);
};
